import { useState, useEffect } from 'react';
import { Modal, Badge } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import DataTable from 'react-data-table-component';

import { limpiarProductoConfiguracion, obtenerProductoConfiguracion } from '../../../actions/configuracion';

import { formatNumber } from '../../../utils/generalFunctions';

const tiposFilter = [
    { value: 1, label: 'Inventario' },
    { value: 2, label: 'Uso' },
    { value: 3, label: 'Venta' }
];

const tipoControlFilter = [
    { value: 0, label: 'Venta libre' },
    { value: 1, label: 'Controlado Grupo I' },
    { value: 2, label: 'Controlado Grupo II' },
    { value: 3, label: 'Controlado Grupo III' },
    { value: 4, label: 'Controlado Grupo IV' },
    { value: 5, label: 'Controlado Grupo V' }
];

const DetallesProducto = ({ producto, reestablecerProducto }) => {

    const dispatch =  useDispatch();

    const { detalles } = useSelector(state => state.configuracion.productos);
    const { listado: listado_unidades } = useSelector(state => state.configuracion.unidades);

    const [detallesModal, setDetallesModal] = useState(false);

    const [productoData, setProductoData] = useState({
        id: null,
        nombre: null,
        fabricante: null,
        categoria: null,
        subcategoria: null,
        subsubcategoria: null,
        codigo_barras: null,
        clave_alternativa: null,
        reorden: null,
        precio_compra: 0,
        precio_venta: 0,
        descripcion: null,
        tipo_control: 0,
        unidades: []
    });

    const columnsUnidades = [
        {
            name: 'Tipo',
            cell: row => tiposFilter.find(tipo => tipo.value == row.tipo)?.label || 'Sin definir'
        },
        {
            name: 'Unidad',
            cell: row => listado_unidades.find(unidad => unidad.id == row.id_unidad)?.nombre || 'Sin definir'
        },
        {
            name: 'Cantidad',
            cell: row => formatNumber(row.cantidad, 2, '', '')
        }
    ];

    /* Detalles producto */
    const handleCerrar = () => {
        setProductoData({
            id: null,
            nombre: null,
            fabricante: null,
            categoria: null,
            subcategoria: null,
            subsubcategoria: null,
            codigo_barras: null,
            clave_alternativa: null,
            reorden: null,
            precio_compra: 0,
            precio_venta: 0,
            descripcion: null,
            tipo_control: 0,
            unidades: []
        });

        setDetallesModal(false);
        reestablecerProducto(null);

        dispatch(limpiarProductoConfiguracion());
    }

    useEffect(() => {
        if(producto){
            setDetallesModal(true);

            dispatch(obtenerProductoConfiguracion(producto?.id));

            setProductoData({
                ...productoData,
                categoria: producto?.categoria?.nombre,
                subcategoria: producto?.subcategoria?.nombre,
                subsubcategoria: producto?.subsubcategoria?.nombre
            });
        }
    }, [producto]);

    useEffect(() => {
        if(detalles){
            setProductoData({
                ...productoData,
                id: detalles?.id,
                nombre: detalles?.nombre,
                fabricante: detalles?.fabricante,
                categoria: producto?.categoria?.nombre,
                subcategoria: producto?.subcategoria?.nombre,
                subsubcategoria: producto?.subsubcategoria?.nombre,
                codigo_barras: detalles?.codigo_barras,
                clave_alternativa: detalles?.clave_alternativa,
                reorden: detalles?.reorden,
                precio_compra: detalles?.precio_compra,
                precio_venta: detalles?.precio_venta,
                descripcion: detalles?.descripcion,
                tipo_control: detalles?.tipo_control || 0,
                unidades: detalles?.unidades || []
            });
        }
    }, [detalles]);

    return (
        <Modal show={detallesModal} size="lg" backdrop="static" centered onHide={() => handleCerrar()}>
            <Modal.Header closeButton>
                <Modal.Title>Información del producto</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    <div className="col-md-6">
                        <label className="fw-bold">Nombre</label>
                        <p>{productoData?.nombre || 'Sin definir'}</p>
                    </div>

                    <div className="col-md-6">
                        <label className="fw-bold">Fabricante</label>
                        <p>{productoData?.fabricante || 'Sin definir'}</p>
                    </div>

                    <div className="col-md-4">
                        <label className="fw-bold">Categoría</label>
                        <p>{productoData?.categoria || 'Sin definir'}</p>
                    </div>

                    <div className="col-md-4">
                        <label className="fw-bold">Subcategoría</label>
                        <p>{productoData?.subcategoria || 'Sin definir'}</p>
                    </div>

                    <div className="col-md-4">
                        <label className="fw-bold">Subsubcategoría</label>
                        <p>{productoData?.subsubcategoria || 'Sin definir'}</p>
                    </div>

                    <div className="col-md-4">
                        <label className="fw-bold">Código de barras</label>
                        <p>{productoData?.codigo_barras || 'Sin definir'}</p>
                    </div>

                    <div className="col-md-4">
                        <label className="fw-bold">Clave alternativa</label>
                        <p>{productoData?.clave_alternativa || 'Sin definir'}</p>
                    </div>

                    <div className="col-md-4">
                        <label className="fw-bold">Punto de reorden</label>
                        <p>{formatNumber(productoData?.reorden, 0, '', '')}</p>
                    </div>

                    <div className="col-md-6">
                        <label className="fw-bold">Costo</label>
                        <p>{formatNumber(productoData?.precio_compra, 2, '$ ', '')}</p>
                    </div>

                    <div className="col-md-6">
                        <label className="fw-bold">Precio</label>
                        <p>{formatNumber(productoData?.precio_venta, 2, '$ ', '')}</p>
                    </div>

                    <div className="col-md-12">
                        <label className="fw-bold">Tipo de control</label>
                        <p><Badge pill bg={productoData?.tipo_control > 0 ? 'warning' : 'secondary'}>{tipoControlFilter.find(item => item.value == (productoData?.tipo_control || 0))?.label}</Badge></p>
                    </div>

                    <div className="col-md-12">
                        <label className="fw-bold">Descripción</label>
                        <p>{productoData?.descripcion || 'Sin descripción'}</p>
                    </div>
                </div>

                <hr className="mt-2" />

                <h5>Unidades</h5>

                <DataTable
                    columns={columnsUnidades}
                    data={productoData.unidades}
                    highlightOnHover
                />
            </Modal.Body>
        </Modal>
    )
}

export default DetallesProducto;
